export function PageHeader({ title, children }) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">{title}</h1>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export const Btn = ({ children, variant = "primary", className = "", ...p }) => {
  const v = {
    primary: "bg-[#5aa469] text-white hover:bg-[#4a8a56]",
    outline: "border border-slate-200 bg-white text-slate-800 hover:border-slate-400",
    danger: "bg-rose-50 text-rose-700 hover:bg-rose-100",
    ghost: "text-slate-600 hover:bg-slate-100",
  }[variant];
  return <button className={`inline-flex items-center justify-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-all active:scale-[0.98] disabled:opacity-50 ${v} ${className}`} {...p}>{children}</button>;
};

export const Field = ({ label, children }) => (
  <label className="block text-sm">
    <span className="mb-1 block font-medium text-slate-700">{label}</span>{children}
  </label>
);

export const inp = "w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm outline-none focus:border-[#5aa469] focus:ring-2 focus:ring-[#5aa469]/20";

export function Modal({ open, onClose, title, children, wide }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4" onClick={onClose}>
      <div data-testid="modal" onClick={(e) => e.stopPropagation()} className={`max-h-[90vh] w-full overflow-auto rounded-2xl bg-white p-6 shadow-2xl rise ${wide ? "max-w-4xl" : "max-w-md"}`}>
        {title && <h3 className="mb-4 font-heading text-xl font-bold text-slate-900">{title}</h3>}
        {children}
      </div>
    </div>
  );
}

export const Card = ({ className = "", children, ...p }) => <div className={`rounded-2xl border border-slate-100 bg-white p-5 shadow-sm ${className}`} {...p}>{children}</div>;

export const statusColor = {
  free: "bg-emerald-50 text-emerald-700 border-emerald-200", occupied: "bg-rose-50 text-rose-700 border-rose-200",
  reserved: "bg-violet-50 text-violet-700 border-violet-200", cleaning: "bg-amber-50 text-amber-700 border-amber-200",
  new: "bg-slate-100 text-slate-700", preparing: "bg-amber-50 text-amber-700", ready: "bg-emerald-50 text-emerald-700", served: "bg-sky-50 text-sky-700", cancelled: "bg-rose-50 text-rose-700",
  confirmed: "bg-emerald-50 text-emerald-700", pending: "bg-amber-50 text-amber-700", seated: "bg-sky-50 text-sky-700", completed: "bg-slate-100 text-slate-600", no_show: "bg-rose-50 text-rose-700",
};
export const Badge = ({ s, label }) => <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${statusColor[s] || "bg-slate-100 text-slate-700"}`}>{label}</span>;

export const elapsed = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
